import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import BespokeShoppingHero from '../components/sections/BespokeShoppingHero'
import BespokeShoppingServiceSection from '../components/sections/BespokeShoppingServiceSection'
import ElevatedPersonalShoppingSection from '../components/sections/ElevatedPersonalShoppingSection'
import SeamlessCuratedExperiencesSection from '../components/sections/SeamlessCuratedExperiencesSection'
import WhyFGAPrestigeSection from '../components/sections/WhyFGAPrestigeSection'
import MemberTestimonialsSection from '../components/sections/MemberTestimonialsSection'
import RetailPartnersSection from '../components/sections/RetailPartnersSection'
import MasterpieceSection from '../components/sections/MasterpieceSection'

const BespokeShoppingPage: React.FC = () => {
  const router = useNavigate()
  
  return (
    <>
      <Helmet>
        <title>Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Discover exclusive bespoke shopping experiences at FGA Prestige." />
      </Helmet>
      
      <main className="min-h-screen">
        {/* Hero Section - Same style as landing page */}
        <BespokeShoppingHero />

        <div style={{ backgroundColor: '#F7F8FA', padding: '64px 0' }}>
          <div className="max-w-6xl mx-auto px-6 text-center">
            <p style={{ fontFamily: 'Cardo, serif' }}>At FGA Prestige, we stay ahead of the curve. Drawing on our trusted global network, our curated articles showcase the latest in luxury living—from bespoke travel and fine dining to art, wellness, and beyond. Stay informed and inspired with what’s new, noteworthy, and tailored for you.</p>
          </div>
        </div>


        {/* Bespoke Shopping Service Section */}
        <BespokeShoppingServiceSection />

        {/* Elevated Personal Shopping Section */}
        <ElevatedPersonalShoppingSection />
        
        {/* Seamless, Curated Experiences Section */}
        <SeamlessCuratedExperiencesSection />
        
        {/* Why FGA Prestige Section */}
        <WhyFGAPrestigeSection />
        
        {/* Member Testimonials Section - Awaiting design instructions */}
        <MemberTestimonialsSection />
        
        {/* Retail Partners Section - Version A (White background) */}
        <RetailPartnersSection
          mainHeading="DIAMONDS"
          description="Securing exceptional diamonds with expert guidance on quality and value."
          imageSrc="/Bespoke Shopping/Retail Partners/DIAMONDS.png"
          imageAlt="Diamonds"
          onButtonClick={() => router('/bespoke-shopping/diamonds')}
        />
        
        {/* Retail Partners Section - Version B (Light gray background) */}
        <RetailPartnersSection
          mainHeading="WATCHES"
          description="Curating the finest timepieces from prestigious watchmakers worldwide."
          imageSrc="/Bespoke Shopping/Retail Partners/WATCHES.png"
          imageAlt="Luxury Watches"
          backgroundColor="#F7F8FA"
          onButtonClick={() => router('/bespoke-shopping/watches')}
        />

        {/* Retail Partners Section - Version F (White background) */}
        <RetailPartnersSection
          mainHeading="CIGARS"
          description="Curating premium cigars and rare tobacco from exclusive manufacturers."
          imageSrc="/Bespoke Shopping/Retail Partners/CIGARS.png"
          imageAlt="Premium Cigars"
          backgroundColor="#FFFFFF"
          onButtonClick={() => router('/bespoke-shopping/cigars')}
        />

        {/* Retail Partners Section - Version E (Light gray background) */}
        <RetailPartnersSection
          mainHeading="WHISKEY"
          description="Collecting rare and vintage whiskeys from renowned distilleries worldwide."
          imageSrc="/Bespoke Shopping/Retail Partners/WHISKEY.png"
          imageAlt="Premium Whiskey"
          backgroundColor="#F7F8FA"
          onButtonClick={() => router('/bespoke-shopping/whiskey')}
        />

        {/* Retail Partners Section - Version G (White background) */}
        <RetailPartnersSection
          mainHeading="MOUTAI"
          description="Providing access to exclusive Moutai collections and limited editions."
          imageSrc="/Bespoke Shopping/Retail Partners/MOUTAI.png"
          imageAlt="Moutai Collection"
          onButtonClick={() => router('/bespoke-shopping/moutai')}
        />

        {/* Retail Partners Section - Version D (Light gray background) */}
        <RetailPartnersSection
          mainHeading="ARTWORK"
          description="Acquiring museum-quality art pieces and investment-grade masterworks."
          imageSrc="/Bespoke Shopping/Retail Partners/ARTWORK.png"
          imageAlt="Fine Art"
          backgroundColor="#F7F8FA"
          onButtonClick={() => router('/bespoke-shopping/artwork')}
        />
        
        {/* Retail Partners Section - Version C (White background) */}
        <RetailPartnersSection
          mainHeading="FINE WINE"
          description="Sourcing rare and exceptional wines from the world's most prestigious vineyards."
          imageSrc="/Bespoke Shopping/Retail Partners/FINE WINE.png"
          imageAlt="Fine Wine"
          onButtonClick={() => router('/bespoke-shopping/fine-wine')}
        />
        
        {/* Retail Partners Section - Version H (Light gray background) */}
        <RetailPartnersSection
          mainHeading="ESTATES"
          description="Facilitating luxury real estate acquisitions and exclusive property investments."
          imageSrc="/Bespoke Shopping/Retail Partners/ESTATES.png"
          imageAlt="Luxury Estates"
          backgroundColor="#F7F8FA"
          onButtonClick={() => router('/bespoke-shopping/estates')}
        />
        
        
        {/* Your Life, Our Masterpiece - Copy from landing page */}
        <MasterpieceSection />
        
      </main>
    </>
  )
}

export default BespokeShoppingPage